import styled from 'styled-components';
import { NavLink as Link } from 'react-router-dom';

export const NavContainer = styled.nav`
  top: 0;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  color: var(--textColor);
  height: 4rem;
  display: flex;
  align-items: center; /* Vertically centers content */
  justify-content: space-between;
  width: 100%;
  z-index: 1000;
  padding: 0 7rem;

  @media screen and (max-width: 768px) {
    padding: 0 0rem;
  }
`;

export const Links = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 2rem;
`;

export const Logo1 = styled.h3`
  border: 3px solid var(--main-color);
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  margin-left: 2rem;
  margin-top: 0.5rem;

  @media screen and (max-width: 375px) {
    font-size: 1.1rem;
  }
`;

export const Logo2 = styled.h3`
  line-height: 1;
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  margin-top: 0.5rem;
  font-weight: bold;

  @media screen and (max-width: 375px) {
    font-size: 1.1rem;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 425px) {
    padding-right: 2rem;
    margin-left: -1rem;
  }
`;

export const LoginLink = styled(Link)`
  border-radius: 8px;
  background-color: var(--main-color);
  font-size: 15px; 
  padding: 10px 20px;
  color: white;
  border: none;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    background: var(--hover-color);
    color: white;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.8rem;
  }
`;